import { Typography } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

import { Switch } from '@/components/Form/Switch';

import { MinorAddressFormType } from '@/constants/minor';

import { useTranslate } from '@/hooks/useTranslate';

import {
  ShareAddressBox,
  ShareAddressToggleContainer,
} from '../MinorProofOfAddressDrawer.styled';

type MinorShareAddressToggleProps = {
  onLiveWithMeChange?: (isLiveWithMe: boolean) => void;
};

export function MinorShareAddressToggle({
  onLiveWithMeChange,
}: Readonly<MinorShareAddressToggleProps>) {
  const { t } = useTranslate();

  const { control } = useFormContext<MinorAddressFormType>();

  return (
    <ShareAddressToggleContainer>
      <ShareAddressBox>
        <Typography variant="bodyB2Regular">
          {t('minorPoA.shareAddress.label')}
        </Typography>
      </ShareAddressBox>
      <Controller
        name="shareAddress"
        control={control}
        render={({ field }) => (
          <Switch
            checked={field.value}
            onChange={(event, checked) => {
              field.onChange(event);
              if (onLiveWithMeChange) {
                onLiveWithMeChange(checked);
              }
            }}
          />
        )}
      />
    </ShareAddressToggleContainer>
  );
}
